import { connect } from 'react-redux';
import * as R from 'ramda';

// Component
import TimeSection from './TimeSection';

// Functions
import { getItem } from '../../store/rackWaitTimesSlice';

const mapState = R.applySpec({
  activeLocation: getItem('activeLocation'),
  locationDetails: getItem('locationDetails'),
  locationLoadTimes: getItem('locationLoadTimes'),
});

const mapDispatchToProps = {};

export default connect(mapState, mapDispatchToProps)(TimeSection);
